export default ({ request }) => ({
  orderDashboardListApi(data = {}) {
    return request({
      url: '/factory/order/dashboard/list',
      method: 'post',
      data
    })
  },
  reportTeamInputListApi(data = {}) {
    return request({
      url: '/factory/report/team/input/list',
      method: 'post',
      data
    })
  },
  reportTeamInputListDepApi(data = {}) {
    return request({
      url: '/factory/report/team/input/listDep',
      method: 'post',
      data
    })
  },
  reportTeamInputListTeamLeaderDepApi(data = {}) {
    return request({
      url: '/factory/report/team/input/listTeamLeader',
      method: 'post',
      data
    })
  }
})
